module.exports = __webpack_public_path__ + "img/Billionaire-2.6ee6595e.gif";